import Rellax from "rellax";

let rellax = null;

function initRellax() {
  const rellaxElements = document.querySelectorAll('.rellax');

  // Destroy existing instance if it exists
  if (rellax) {
    rellax.destroy();
    rellax = null;
  }

  // Re-initialize if elements exist
  if (rellaxElements.length > 0) {
    rellax = new Rellax('.rellax', {
      center: true
    });
  }
}

// Initial load
initRellax();

// Handle window resize
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (rellax) {
      rellax.refresh();
    }
  }, 250);
});

// Re-initialize on Shopify Customizer changes
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initRellax);
  document.addEventListener('shopify:section:unload', initRellax);
  document.addEventListener('shopify:section:select', initRellax);
  document.addEventListener('shopify:section:deselect', initRellax);
}
